/**
 * @module events/types/dragStart
 */

/**
 * @type {string}
 */
export default 'dragstart'
